{
	"common": {
		"add": "Añadir",
		"cancel": "Cancelar",
		"create": "Crear",
		"delete": "Eliminar",
		"done": "Listo",
		"e-mail": "Correo electrónico",
		"edit": "Editar",
		"get-started": "Empezar",
		"language": "Idioma",
		"next": "Siguiente",
		"no": "No",
		"optional": "opcional",
		"or": "O",
		"password": "Contraseña",
		"password-requirements-hint": "Mínimo {{minLength}} caracteres, un número, un carácter especial",
		"read-more": "Leer más",
		"save": "Guardar",
		"saving": "Guardando",
		"search": "Buscar",
		"select": "Seleccionar",
		"select-all": "Seleccionar todo",
		"selected": "Seleccionado",
		"selected-all": "Todo seleccionado",
		"send": "Enviar",
		"show-less": "Mostrar menos",
		"sign-out": "Cerrar sesión",
		"skip": "Omitir",
		"username": "Nombre de usuario",
		"yes": "Sí",
		"enter-your-email": "Introduce tu correo electrónico",
		"enter-your-username": "Ingrese su nombre de usuario",
		"create-a-password": "Crear una contraseña",
		"enter-your-password": "Ingresa tu contraseña"
	},
	"flag": "🇪🇸",
	"forgot-password": {
		"sent-please-check-your-email": "Enviado, por favor revisa tu correo electrónico"
	},
	"profile": {
		"delete-account": "Eliminar cuenta",
		"this-action-cannot-be-undone": "Esta acción no puede deshacerse"
	},
	"login": {
		"create-new-password": "Crear contraseña nueva",
		"dont-have-an-account": "¿No tienes una cuenta?",
		"forgot-password": "¿Olvidaste tu contraseña?",
		"please-enter-your-email-an-email-will-be-sent-to-it-to-reset-your-password": "Por favor, introduce tu correo electrónico, recibirás un correo electrónico para restablecer tu contraseña",
		"set-new-password": "Establecer contraseña nueva",
		"sign-in": "Iniciar sesión",
		"sign-up": "Registrarme",
		"to-keep-connected-with-us-please-login-to-your-account": "Para mantenerte conectado con nosotros, inicia sesión en tu cuenta",
		"welcome-back": "¡Bienvenido/a de nuevo!",
		"password-updated": "Contraseña actualiza",
		"your-password-has-been-successfully-changed": "Su contraseña ha sido cambiada exitosamente.",
		"password-set-successfully": "Contraseña establecida correctamente",
		"you-can-login-now": "Puedes iniciar sesión ahora"
	},
	"register": {
		"agree-to": "Al crear una cuenta, aceptas nuestra",
		"create-account": "Crear cuenta",
		"do-you-have-account": "¿Ya tienes cuenta?",
		"hello-friend": "¡Hola, amigo/a!",
		"privacy-policy-and-eula": "Política de privacidad y Acuerdo de licencia del usuario final",
		"provide-your-personal-details": "Proporciona tus detalles personales y comienza a desarrollar con nosotros",
		"repeat-password": "Repetir contraseña",
		"sign-up-for-a-newsletter": "¡Suscríbete a nuestro newsletter y sé parte de nuestra comunidad!"
	},
	"validations": {
		"error": "Error"
	},
	"change-password": {
		"modal": {
			"title": "Cambiar la contraseña",
			"submit": "Cambiar la contraseña"
		},
		"old-password": "Contraseña anterior",
		"new-password": "Nueva contraseña",
		"repeat-new-password": "Repita la nueva contraseña",
		"invalid-password": "Contraseña no válida",
		"passwords-do-not-match": "Las contraseñas no coinciden",
		"password-changed": "Se ha cambiado la contraseña",
		"new-password-must-be-different-from-the-old-one": "Nueva contraseña debe ser diferente de la anterior"
	}
}
